import CurrencyNumber from "app/components/CurrencyNumber/CurrencyNumber";
import { UserType } from "app/types/userType";
import { FormattedMessage } from "react-intl";
import "./FirstTimeDepositMinimum.scss";

type Props = {
  user: UserType;
};
function FirstTimeDepositMinimum(props: Props) {
  // Launch the widgit withT&C opened
  const launchTaCWidgit = () => {
    // @ts-ignore
    FreshworksWidget("open", "article", {
      id: 103000015424,
    });
  };

  const firstTimeMinimumDeposit = props.user.firstTimeMinimumDeposit || "";
  return (
    <div className="ftmd">
      <FormattedMessage
        id="minimum-deposit-message"
        values={{
          minimumDeposit: (
            <CurrencyNumber
              id="minimum-deposit"
              value={firstTimeMinimumDeposit}
              hideDecimalIfZeros={true}
            />
          ),
        }}
      />{" "}
      <span
        className="ftmd__tac-link"
        onClick={e => {
          launchTaCWidgit();
        }}
      >
        <FormattedMessage id="termsandconditions" />
      </span>
    </div>
  );
}
export default FirstTimeDepositMinimum;
